module.exports = __webpack_public_path__ + "img/web-17.b514777b.gif";